export default __webpack_public_path__ + "static/Baked1-bb564da3ebc6f48241bb2bdb99890c75.png";